<template>

    <Head title="Perfil" />

    <div class="shadow_box rounded-lg p-6 mt-4">
        <h1 class="mb-6 text-2xl text-gray-777 font-roboto uppercase">
            <span class="whitespace-nowrap overflow-hidden">Perfil</span>
        </h1>
        
        <form @submit.prevent="handleUpdateProfile" method="post" class="flex-1 lg:flex flex-wrap">
            <fieldset class="flex-1 mb-10 lg:max-w-[600px]">
                <photo-input 
                    v-model="form.photo" 
                    :error="form.errors[`photo.upload`]" 
                    class="pb-8 lg:pr-6 w-full flex flex-col items-center"
                    type="file" label="Foto" />

                <p class="font-roboto text-2xl font-normal text-center">
                    {{ user.name }}
                </p>
                <p class="font-roboto text-base text-[#9C9C9C] font-normal text-center">
                    {{ user.email }}
                </p>
            </fieldset>

            <fieldset class="flex-1">
                <text-input 
                    v-model="form.name" 
                    :error="form.errors.name" 
                    class="pb-8 lg:pr-6 w-full lg:w-1/2 lg:inline-block" 
                    label="Nome"
                    required="true" />

                <text-input 
                    v-model="form.email" 
                    :error="form.errors.email" 
                    class="pb-8 lg:pr-6 w-full lg:w-1/2 lg:inline-block"
                    label="E-mail"
                    required="true" />

                <button 
                    v-if="!changePassword" 
                    type="button" 
                    class="btn-primary font-normal text-xs px-6 py-2.5 "
                    @click="changePassword = true">
                        <font-awesome-icon icon="fa-lock" class="mr-2" /> Alterar senha
                </button>

                <password-input 
                    v-if="changePassword"
                    v-model="form.password" 
                    :error="form.errors.password"
                    class="inline-block pb-8 lg:pr-6 w-full lg:w-1/2" 
                    label="Nova senha" />

                <password-input 
                    v-if="changePassword"
                    v-model="form.password_confirmation"
                    :error="form.errors.password_confirmation" 
                    class="inline-block pb-8 w-full lg:w-1/2" 
                    label="Confirme a nova senha" />


                <div class="flex justify-end">
                    <loading-button 
                        :loading="form.processing" 
                        class="btn-purple " 
                        type="submit">
                            Salvar
                    </loading-button>
                </div>
            </fieldset>
        </form>
    </div>

</template>


<script>

import { Head, useForm } from '@inertiajs/inertia-vue3'

import ProviderLayout from '@/Shared/ProviderLayout'
import PhotoInput from '@/Shared/PhotoInput'
import TextInput from '@/Shared/TextInput'
import PasswordInput from '@/Shared/PasswordInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {

    components: {
        Head,
        PhotoInput,
        TextInput,
        PasswordInput,
        LoadingButton,
    },

    layout: ProviderLayout,

    props: {
        user: Object,
    },

    data() {
        return {
            changePassword: false,

            form: useForm({
                photo: {
                    name: this.$props.user.photo?.name,
                    size: this.$props.user.photo?.size,
                    url: this.$props.user.photo?.url,
                },
                name: this.$props.user.name,
                email: this.$props.user.email,
                password: null,
                password_confirmation: null,
            })
        }
    },


    methods: {

        handleSuccessUpdate() {
            this.$toast.success('Perfil atualizado com sucesso.')
        },

        handleErrorUpdate(error) {
            console.log(error)
            this.$toast.error('Erro ao atualizar perfil.')
        },

        handleUpdateProfile() {

            this.form.post('/provider/profile', {
                onSuccess: this.handleSuccessUpdate,
                onError: this.handleErrorUpdate,
            })

        }, 

    },    

}

</script>
